import {createGlobalStyle} from "styled-components";

const GlobalStyles = createGlobalStyle`
html,body{
  background-color: #FAFAFA !important;
}
*{
   margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
}

.validation-error {
    white-space: pre-line;
    width: 100%;
    padding: 0.3rem 1rem;
    font-size: 11px;
    color: #ef4444;
    background-color: rgba(239, 68, 68, 0.1);
    border-radius: 0.375rem;
    margin-top: 0.25rem;
    animation: flash 0.3s ease-in-out;
    animation-iteration-count: 3;
    @keyframes flash {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }

  .litepicker{
      z-index: 99999 !important;
    }
  
  .phone-black {
    input {
      background: white !important;
      color: black !important;
      border: 1px solid #d1d5db;
      border-radius: 0.375rem;
      padding: 0.5rem;
    }
  }

  /* Modern React Phone Input styling */
  .modern-phone-input .PhoneInput {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px; /* Fixed height to match other inputs */
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    background: white;
    transition: all 0.2s ease-in-out;
    
    &:hover {
      border-color: #9ca3af;
    }
    
    &:focus-within {
      outline: none;
      box-shadow: 0 0 0 2px #3b82f6;
      border-color: transparent;
    }
    
    .PhoneInputCountrySelect {
      display: flex;
      align-items: center;
      padding: 0 0.75rem;
      height: 100%;
      border: none;
      background: transparent;
      cursor: pointer;
      
      &:focus {
        outline: none;
      }
    }
    
    .PhoneInputCountryIcon {
      width: 1.25rem;
      height: 1rem;
      margin-right: 0.5rem;
    }
    
    .PhoneInputCountrySelectArrow {
      width: 0.75rem;
      height: 0.75rem;
      margin-left: 0.25rem;
      color: #6b7280;
    }
    
    input.PhoneInputInput {
      flex: 1;
      height: 100%;
      padding: 0 0.75rem;
      border: none;
      background: transparent;
      font-size: 0.875rem;
      color: #111827;
      outline: none;
      
      &::placeholder {
        color: #6b7280;
      }
    }
  }

  /* Error state for phone input */
  .modern-phone-input.error .PhoneInput {
    border-color: #ef4444;
    
    &:focus-within {
      box-shadow: 0 0 0 2px #ef4444;
    }
  }

  /* Legacy phone input styling for backward compatibility */
  .phoneInputContainer .PhoneInput {
    input {
      background: white !important;
      color: black !important;
    }
  }

  /* Modern button utility classes for backward compatibility */
  .modern-btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    border-radius: 0.5rem;
    background-color: #2563eb;
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    
    &:hover {
      background-color: #1d4ed8;
    }
    
    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px #3b82f6;
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .modern-btn-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    border-radius: 0.5rem;
    background-color: #f3f4f6;
    color: #374151;
    border: 1px solid #d1d5db;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    
    &:hover {
      background-color: #e5e7eb;
    }
    
    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px #6b7280;
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  /* Modern select utility class */
  .modern-select {
    width: 100%;
    height: 48px;
    appearance: none;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    background: white;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
    background-position: right 0.75rem center;
    background-repeat: no-repeat;
    background-size: 1.25rem 1.25rem;
    padding: 0 2.5rem 0 1rem;
    font-size: 0.875rem;
    color: #111827;
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    &:hover {
      border-color: #9ca3af;
    }

    &:focus {
      outline: none;
      border-color: transparent;
      box-shadow: 0 0 0 2px #3b82f6;
    }

    &:disabled {
      background-color: #f9fafb;
      color: #6b7280;
      cursor: not-allowed;
    }

    &.error {
      border-color: #ef4444;
      
      &:focus {
        box-shadow: 0 0 0 2px #ef4444;
      }
    }
  }

  /* Headless UI Combobox and Listbox option styling */
  .modern-option {
    padding: 0.75rem 1rem;
    cursor: pointer;
    transition: all 0.15s ease-in-out;
    
    &:hover, &[data-headlessui-state~="active"] {
      background-color: #f3f4f6;
    }
    
    &[data-headlessui-state~="selected"] {
      background-color: #3b82f6;
      color: white;
    }
  }
`;

export default GlobalStyles;
